import capitalize from 'lodash/capitalize';

import getParent from '../selectors';

export const getTestSelection = state =>
  getParent(state).testSelection;

export const getCapitalizedTestSelection = state =>
  capitalize(getTestSelection(state));

export default getTestSelection;
